/** Query keys for customer-service-rep CRUD + assignment queries. */
export const customerServiceRepQueryKeys = {
  all: ['customer-service-rep'] as const,
  lists: () => [...customerServiceRepQueryKeys.all, 'list'] as const,
  list: (filters: { page?: number; pageSize?: number }) =>
    [...customerServiceRepQueryKeys.lists(), filters] as const,
  details: () => [...customerServiceRepQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...customerServiceRepQueryKeys.details(), id] as const,
};

export const customerServiceRepAssignmentsQueryKeys = {
  all: ['customer-service-rep-assignments'] as const,
  lists: () => [...customerServiceRepAssignmentsQueryKeys.all, 'list'] as const,
  list: (filters: {
    customerServiceRepId?: string;
    customerId?: string;
    page?: number;
    pageSize?: number;
  }) => [...customerServiceRepAssignmentsQueryKeys.lists(), filters] as const,
};
